import AuthProvider from "./core/Authentication/AuthProvider"
import AppRouter from "./routers/AppRouter"
import ReactGA from 'react-ga4'

const TRACKING_ID = "G-JKN1GTPZ9D"
ReactGA.initialize(TRACKING_ID)

function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
